import 'jquery-ui/ui/widgets/accordion'

export function initQuestionsToggler() {
  const questionsEl = document.querySelector('.js-questions-toggle')

  if (!questionsEl) return

  $(questionsEl).accordion({
    collapsible: true,
    header: '.js-questions-toggle-button',
    heightStyle: 'content',
    active: false,
  })
}
